import { Icon, Stack, Text } from "prism-react";

interface Props {
  message: string;
}

export const ShellError: React.FC<Props> = ({ message }) => (
  <Stack
    css={{
      display: "flex",
      alignItems: "center",
      color: "$informative-error-base",
      padding: "$3",
    }}
    horizontal
  >
    <Icon size={4} type="circleBang" />
    <Text>{message}</Text>
  </Stack>
);
